import React from 'react';
import { connect } from 'react-redux';
import {
  TextField,
} from '@mui/material';
import { IAppState } from '../../../../../../state/reducers';
import {
  updatePublishingMetadataField,
} from '../../../../../../state/publishAssets';
import {
  IProps,
  IStateProps,
  IOwnProps,
  IDispatchProps,
} from './interfaces';
import {
  ControlLabel,
  ControlContainer,
  LabelContainer,
  CharactersLeft,
} from './styles';
import { SocialPublish } from '../../../../../../constants';
import EmojiSelector from '../../EmojiSelector/component';

class PublishingMetadataField extends React.Component<IProps> {
  private maxLength?: number;

  constructor(props: IProps) {
    super(props);

    this.maxLength = SocialPublish.FIELDS_MAX_LENGTH.get(props.fieldName);
  }
  selectEnteredValue = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select();
  };

  render() {
    const {
      value,
      label,
      fieldName,
      multiline,
      rows,
      updatePublishingMetadataFieldConnect,
      withEmojis,
    } = this.props;

    return (
      <ControlContainer>
        <LabelContainer>
          <ControlLabel>{label}</ControlLabel>
          <CharactersLeft>
            {this.maxLength - value.length}
          </CharactersLeft>
        </LabelContainer>
        <TextField
          fullWidth
          margin="dense"
          variant="outlined"
          value={value}
          onChange={(e) => updatePublishingMetadataFieldConnect(fieldName, e.target.value)}
          inputProps={{
            maxLength: this.maxLength,
          }}
          onFocus={this.selectEnteredValue}
          multiline={multiline}
          rows={rows}
        />
        { withEmojis && <EmojiSelector fieldName={fieldName} value={value} updateFunction={updatePublishingMetadataFieldConnect} /> }
      </ControlContainer>
    );
  }
}

const mapStateToProps = (state: IAppState, ownProps: IOwnProps): IStateProps => ({
  value: state.publishSelectedAssetsToEndPoints.socialPublishing.metadata[ownProps.fieldName],
});

const mapDispatchToProps: IDispatchProps = {
  updatePublishingMetadataFieldConnect: updatePublishingMetadataField,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PublishingMetadataField);
